import React, {Component} from 'react';
import PageHeader from "../PageHeader";
import Menu from "../Menu";
import Preloader from "../Preloader";
import api from "../../api";
import './MyRecord.scss';

export class ClientSearch extends Component<any, any> {
    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            clientSearchQuery: '',
            clientSearchResults: [],
            clientSearchLoading: false,
            clientSearchError: '',
            clientCardOpen: false,
            clientCard: null,
            clientFormula: '',
            clientCardSaving: false,
            clientCardError: '',
        };
    }

    latestServiceText(latestService) {
        if (!latestService) {
            return '';
        }
        const services = Array.isArray(latestService.services) ? latestService.services.join(', ') : '';
        return [latestService.date, services].filter(Boolean).join(' — ');
    }

    searchClients() {
        const query = String(this.state.clientSearchQuery || '').trim();
        if (query.length < 2) {
            this.setState({
                clientSearchResults: [],
                clientSearchError: 'Введите имя или телефон клиента',
            });
            return;
        }

        this.setState({clientSearchLoading: true, clientSearchError: ''});
        api({
            url: '/widget/staff/v2/clients/search',
            method: 'GET',
            params: {q: query},
        }).then((result) => {
            this.setState({
                clientSearchLoading: false,
                clientSearchResults: Array.isArray(result.data?.items) ? result.data.items : [],
            });
        }).catch(() => {
            this.setState({
                clientSearchLoading: false,
                clientSearchError: 'Не удалось найти клиента',
            });
        });
    }

    handleClientSearchKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.searchClients();
        }
    }

    openClientCard(clientId) {
        if (!clientId) {
            return;
        }
        this.setState({clientCardOpen: true, clientCard: null, clientFormula: '', clientCardError: ''});
        api({
            url: '/widget/staff/v2/clients/' + clientId + '/card',
            method: 'GET',
        }).then((result) => {
            this.setState({
                clientCard: result.data,
                clientFormula: result.data?.formula?.value || '',
            });
        }).catch(() => {
            this.setState({clientCardError: 'Не удалось открыть карточку клиента'});
        });
    }

    saveClientCard() {
        const clientId = this.state.clientCard?.client?.id;
        if (!clientId || this.state.clientCardSaving) {
            return;
        }
        this.setState({clientCardSaving: true, clientCardError: ''});
        api({
            url: '/widget/staff/v2/clients/' + clientId + '/card',
            method: 'PUT',
            data: {formula: this.state.clientFormula},
        }).then((result) => {
            this.setState({
                clientCard: result.data,
                clientFormula: result.data?.formula?.value || '',
                clientCardSaving: false,
            });
        }).catch(() => {
            this.setState({clientCardSaving: false, clientCardError: 'Не удалось сохранить формулу'});
        });
    }

    renderClientCard() {
        if (!this.state.clientCardOpen) {
            return null;
        }
        const card = this.state.clientCard;
        return (
            <div className='changePointBlock'>
                <div className='changePoint staff-client-card-modal' style={{maxHeight: '85vh', overflowY: 'auto'}}>
                    <div className='staff-client-card-head'>
                        <div>
                            <div className='txt-large bold'>Карточка клиента</div>
                            <div className='staff-client-card-note'>Данные видит только сотрудник</div>
                        </div>
                        <button
                            type='button'
                            className='staff-client-card-close-icon'
                            onClick={() => this.setState({clientCardOpen: false})}
                        >
                            x
                        </button>
                    </div>
                    {this.state.clientCardError ? (
                        <div className='txt-middle mb-2' style={{color: '#e72f44'}}>{this.state.clientCardError}</div>
                    ) : null}
                    {!card ? (
                        <Preloader/>
                    ) : (
                        <>
                            <div className='staff-client-card-person'>
                                <div className='txt-middle bold'>{card.client?.name || 'Клиент'}</div>
                                {card.client?.phone ? (
                                    <div className='txt-middle'>{card.client.phone}</div>
                                ) : null}
                            </div>
                            <div className='staff-client-card-block'>
                                <div className='staff-client-card-label'>Последняя услуга</div>
                                <div className='staff-client-card-value'>
                                    {this.latestServiceText(card.latestService) || 'Пока нет завершённых визитов'}
                                </div>
                            </div>
                            <div className='staff-client-card-label mt-3 mb-2'>Формула красителя</div>
                            <textarea
                                className='staff-client-formula'
                                style={{minHeight: 120}}
                                placeholder='Например: тон 7.3, оксид 3%, корни 35 минут'
                                value={this.state.clientFormula}
                                onChange={(event) => this.setState({clientFormula: event.target.value})}
                            />
                            <button
                                type='button'
                                onClick={() => this.saveClientCard()}
                                className='staff-client-card-save'
                                disabled={this.state.clientCardSaving}
                            >
                                {this.state.clientCardSaving ? 'Сохраняем...' : 'Сохранить'}
                            </button>
                            {(card.logs || []).length ? (
                                <div className='mt-3'>
                                    <div className='txt-middle bold mb-2'>История изменений</div>
                                    {(card.logs || []).map((log, index) => (
                                        <div key={index} className='txt-small mb-2'>
                                            <div>{log.createdAt} {log.staffName}</div>
                                            <div>Было: {log.oldValue || 'пусто'}</div>
                                            <div>Стало: {log.newValue || 'пусто'}</div>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </>
                    )}
                    <button
                        type='button'
                        onClick={() => this.setState({clientCardOpen: false})}
                        className='staff-client-card-close-footer'
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='main my-record client-search-page'>
                <div className='content mx-w-content'>
                    {this.renderClientCard()}
                    <PageHeader
                        pageTitle='Поиск клиента'
                        backBtnUrl='/'
                    />
                    <div className='pt-header'></div>

                    <div className='staff-client-search ml-3 mr-3 mb-5'>
                        <div className='staff-client-search-title'>Поиск клиента</div>
                        <div className='staff-client-search-form'>
                            <input
                                className='form-control staff-client-search-input'
                                type='text'
                                placeholder='Имя или телефон'
                                value={this.state.clientSearchQuery}
                                onChange={(event) => this.setState({clientSearchQuery: event.target.value})}
                                onKeyDown={(event) => this.handleClientSearchKeyDown(event)}
                                autoFocus
                            />
                            <button
                                type='button'
                                className='staff-client-search-button'
                                disabled={this.state.clientSearchLoading}
                                onClick={() => this.searchClients()}
                            >
                                {this.state.clientSearchLoading ? 'Ищем' : 'Найти'}
                            </button>
                        </div>
                        {this.state.clientSearchError ? (
                            <div className='staff-client-search-error'>{this.state.clientSearchError}</div>
                        ) : null}
                        {this.state.clientSearchResults.length ? (
                            <div className='staff-client-search-results'>
                                {this.state.clientSearchResults.map((client) => (
                                    <button
                                        type='button'
                                        key={client.id}
                                        className='staff-client-search-result'
                                        onClick={() => this.openClientCard(client.id)}
                                    >
                                        <span>
                                            <strong>{client.name || 'Клиент'}</strong>
                                            {client.phone ? <small>{client.phone}</small> : null}
                                        </span>
                                        <em>{this.latestServiceText(client.latestService) || 'Карточка клиента'}</em>
                                    </button>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </div>
                <Menu/>
            </div>
        );
    }
}

export default ClientSearch;
